import React from 'react'
import {connect} from "react-redux";
import {
  selectFilter,
  updateResults,
  setFilterMode,
  setActiveMode,
  /* redirectToProductFinder, */
  resetOnSearch,
  setActiveSearchMode,
  FilterModes, SearchModes
} from "../../store/actions";
import SearchInput from "../Input/SearchInput";


class SearchMode extends React.Component {

  constructor(props) {
    super(props);
    this.inputRef = React.createRef();
  }

  resetFilters = () => {
    this.props.setFilterMode(FilterModes.SEARCH_MODE, true);
    this.props.setActiveSearchMode(SearchModes.TABLE);
    this.inputRef.current.resetValue();
    this.props.updateResults(false);
  };

  switchToFinder = () => {
    this.props.setFilterMode(FilterModes.FILTER_MODE, true);
    this.props.updateResults(false);
  };

  onFormSubmit = e => {
    e.preventDefault();
    this.submitValue();
  }

  submitValue = () => {
    this.props.setFilterMode(FilterModes.SEARCH_MODE, false);
    this.props.setActiveSearchMode(SearchModes.TABLE);
    this.props.finderRef.current.resetError();
    this.props.resetOnSearch();
    if (this.props.value?.length ) {
      this.props.updateResults(true);
      } else {
        return;
      }
  };

  selectInput = (value) => {
    this.props.selectFilter('search', value);
  };

  onFocus = () => {
    this.props.setActiveMode(FilterModes.SEARCH_MODE);
  };

  render() {
    let className = 'search-mode product-finder-form';
    let disabled;
    if (this.props.activeMode === FilterModes.FILTER_MODE) {
      className += ' inactive';
      disabled = true;
    }
    // never used
    //let head = this.props.redirectMode ? 'h2' : 'h1';
    return (
      <form onSubmit={this.onFormSubmit} onFocus={this.onFocus} className={className}>
        <div className="form--inline">
          <h2 className="form__title block-title">{this.props.strings['STRING:TITLE_SEARCH_MODE']}</h2>
          <SearchInput value={this.props.value || ''} generalSearch={true} ref={this.inputRef} selectInput={this.selectInput} submitResult={this.submitValue} name="search" inputCustomLabel={this.props.strings['STRING:SEARCH_TERM']} placeholder={this.props.strings['STRING:ENTER_SEARCH_TERM']} inputCustomClassName={"search"} />
          <div className="form__actions form-item">
            <button className="button submit" disabled={disabled} onClick={this.submitValue} name="submit" type="submit">{this.props.strings['STRING:FIND_YOUR_PRODUCT']}</button>
            <div className="form__actions__secondary">
              {(!this.props.redirectMode) && (<button disabled={disabled} className="reset" onClick={this.resetFilters} name="reset-filters" type="button">{this.props.strings['STRING:RESET_SEARCH']}</button>)}
            </div>
          </div>
        </div>
      </form>
    );
  }
}

const mapStateToProps = (state) => {
  const mode = state.parameters.mode;
  const activeMode = state.parameters.activeMode;
  const value = state.parameters.filters.search;
  return { mode, activeMode, value }
};

export default connect(
  mapStateToProps,
  { selectFilter, updateResults, setFilterMode, setActiveMode, /* redirectToProductFinder, */ resetOnSearch, setActiveSearchMode }
)(SearchMode)
